import { useState, useEffect } from 'react';
import "./CookiePopup.scss";

const getCookie = (name) => {
    const cookies = document.cookie.split("; ").map(c => c.split("="));
    const cookie = cookies.find(([key]) => key === name);
    return cookie ? cookie[1] : null;
};


const loadAnalytics = () => {
    // Initialize analytics or tracking scripts 
};

const CookiePopup = () => {
    const [show, setShow] = useState(false);


    useEffect(() => {
        const myCookieValue = getCookie("myCookieName");
        if (myCookieValue === "thisIsMyCookie") {
            setShow(false);
        } else {
            setShow(true);
        }
    }, []);

    const acceptCookie = () => {
        let d = new Date();
        d.setMinutes(d.getMinutes() + 2);
        document.cookie = "myCookieName=thisIsMyCookie; expires=" + d.toUTCString() + "; path=/";
        loadAnalytics();          // initialize analytics/scripts here
        setShow(false);
    };

    const declineCookie = () => {
        // You may set a declined marker cookie for compliance:
        let d = new Date();
        d.setMinutes(d.getMinutes() + 2);
        document.cookie = "myCookieName=declined; expires=" + d.toUTCString() + "; path=/";
        setShow(false);           // Do not initialize external scripts here
    };

    if (!show) return null;

    return (
        <div className="show" id="cookiePopup" >
            <p>
                Nasza strona używa plików cookie, aby poprawić Twoje doświadczenia podczas przeglądania strony. Klikając "Akceptuj", zgadzasz się na naszą <a href="/privacy-policy">Politykę Prywatności</a>.
            </p>
            <div className="cookiePopup-buttons">
                <button id="acceptCookie" onClick={acceptCookie}>Akceptuj</button>
                <button id="declineCookie" onClick={declineCookie}>Odrzuć</button>
            </div>
        </div>
    );
};

export default CookiePopup;



